import { useParams } from 'react-router-dom';

import AuditHistoryAccordion from './AuditHistoryAccordion';
import Layout from './Layout';
import { useGetIncomeAuditHistory } from './hooks';

export default function IncomeAuditHistory() {
  const {
    boltAuditPage,
    entity,
    applicableIncomeAuditId,
    applicableIncomeAuditType,
    employerId,
    customerRecordId,
    lenderDatabaseId,
  } = useParams();

  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetIncomeAuditHistory(
    boltAuditPage,
    entity,
    applicableIncomeAuditId,
    applicableIncomeAuditType,
    employerId,
    customerRecordId,
    lenderDatabaseId,
  );

  return (
    <Layout
      pageEnum={boltAuditPage}
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      <AuditHistoryAccordion data={auditHistory} />
    </Layout>
  );
}
